import { Component, Input, Output, EventEmitter, OnInit, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DEFAULT_TOGGLE_CONFIG, ToggleConfig } from './toggle.modal';

@Component({
  selector: 'ds-toggel',
  templateUrl: './toggel.component.html',
  standalone: true,
  imports: [CommonModule]
})
export class ToggelComponent implements OnInit {
  public _toggleInput: ToggleConfig = { ...DEFAULT_TOGGLE_CONFIG };
  @Input() toggleInput!: ToggleConfig;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.toggleInput) {
      const val: ToggleConfig = changes.toggleInput.currentValue || {};
      this.toggleInput = { ...DEFAULT_TOGGLE_CONFIG, ...val };
    }
  }
  @Output() isActiveChange = new EventEmitter<boolean>();

  ngOnInit(): void {
    if (!this.toggleInput?.id) {
      this.toggleInput.id = `ds-toggel-${Math.random().toString(36).slice(2, 9)}`;
    }
  }

  onToggle(ev: Event) {
    if (this.toggleInput?.disabled) return;
    const input = ev.target as HTMLInputElement;
    this.toggleInput.isActive = input.checked;
    this.isActiveChange.emit(this.toggleInput.isActive);
  }
}